<template>
  <div class="mt-1">
    <div style="direction: rtl">زدایندکس</div>
    <el-input dir="ltr" placeholder="z-index" type="number" v-model="number"/>
  </div>
</template>

<script>
export default {
  name: "NumberInput",
  props: {
    zIndex: {},
    element: {}
  },
  data() {
    return {
      number: ''
    }
  },
  mounted() {
    this.number = this.zIndex
  },
  watch: {
    zIndex(val) {
      this.number = val
    },
    number(val) {
        if (val <= 2000) {
          this.$emit('changeConfig', {
            props: 'zIndex',
            value: val,
            id: this.element.id
          })
        } else {
          this.number = 2000
          this.$emit('changeConfig', {
            props: 'zIndex',
            value: 2000,
            id: this.element.id
          })
        }

    }
  }
}
</script>

<style scoped>
.mt-1 {
  margin-top: 12px;
}

.mb-1 {
  margin-bottom: 12px
}
</style>
